import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import Button from "@amzn/meridian/button";
import Theme from "@amzn/meridian/theme";
import orangeLightTokens from "@amzn/meridian-tokens/theme/orange-light";

import { keys } from "i18n";
import DeleteYardMapDialog from "./DeleteYardMapDialog";

function DeleteYardMapButton({ yardId, version }) {
  const [showDialog, setShowDialog] = useState(false);
  const { t } = useTranslation();
  const { permissions } = useSelector((state) => state.permissionsData) || {};

  const canEdit = !!(permissions && permissions.canEdit);

  const handleDeleteClick = () => {
    setShowDialog(true);
  };

  const handleCloseDialog = () => {
    setShowDialog(false);
  };

  return (
    <>
      <Theme tokens={orangeLightTokens}>
        <Button onClick={handleDeleteClick} disabled={!canEdit}>
          {t(keys.DELETE_MAP)}
        </Button>
      </Theme>
      {showDialog && (
        <DeleteYardMapDialog yardId={yardId} version={version} onClose={handleCloseDialog} />
      )}
    </>
  );
}

DeleteYardMapButton.propTypes = {
  yardId: PropTypes.string.isRequired,
  version: PropTypes.number.isRequired,
};

export default DeleteYardMapButton;
